import { useEffect, useState } from "react";
import {
  canSendOtpSakhad,
  markSakhadOtpSent,
} from "../../../utils/OtpRateLimitSakhad";
import Noti from "../general/noti";
import { useSakhadSendOtp } from "../../../hook/request/providerSakhad";

const SakhadOtpTimer = () => {
  const [timer, setTimer] = useState("00:00");
  const [isResendDisabled, setIsResendDisabled] = useState(true);
  const sakhadSendOtpRequest = useSakhadSendOtp();

  useEffect(() => {
    // This interval logic now only affects THIS component.
    const interval = setInterval(() => {
      const { allowed, remainingFormatted } = canSendOtpSakhad();
      if (allowed) {
        setIsResendDisabled(false);
        setTimer("00:00");
        clearInterval(interval);
      } else {
        setIsResendDisabled(true);
        setTimer(remainingFormatted);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []); // Empty dependency array means it runs once on mount.

  const handleResendCode = () => {
    sakhadSendOtpRequest.mutate(undefined, {
      onSuccess: () => {
        Noti("success", "رمز ورود جدید با موفقیت برای شما پیامک شد");
        markSakhadOtpSent();
        setIsResendDisabled(true); // Manually disable after click to restart timer
      },
      onError: () => {
        Noti("error", "خطا در ارسال مجدد رمز. لطفاً دوباره تلاش کنید.");
      },
    });
  };

  return (
    <>
      <button
        className={"btn btn-outline-secondary rounded rounded-4"}
        type={"button"}
        onClick={handleResendCode}
        disabled={isResendDisabled || sakhadSendOtpRequest.isPending}
      >
        {sakhadSendOtpRequest.isPending ? "..." : "ارسال مجدد کد"}
      </button>
      {isResendDisabled && (
        <span className="text-muted font-14">({timer})</span>
      )}
    </>
  );
};

export default SakhadOtpTimer;
